import { useQuery } from '@tanstack/react-query'
import { getLegalEntities } from '../queries/legalEntities.queries'

export const useLegalEntities = () =>
  useQuery({
    queryFn: () => getLegalEntities(),
    queryKey: ['legalEntities', 'list'],
  })
